import { createFileRoute } from "@tanstack/react-router";
import { AssistenteConfigurarAcoesPage } from "@/paginas/pg_assistente/assistente-configurar-acoes";

export const Route = createFileRoute("/_authenticated/assistente-configurar-acoes")({
  component: AssistenteConfigurarAcoesPage,
});
